import {combineReducers} from 'redux';

import recordsReducer from './recordsSlice';


export const ResetPasswordReducer = combineReducers({
                                                        records: recordsReducer,
                                                    });
